import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { stopPropagation } from '../../../utils/events'
import { FloatingTooltip } from '../../Floating'
import { IconNG } from '../../Icon'

import * as styles from './EmailImportantButton.module.css'

import StarEmptyIcon from '../../../icons/star.svg'
import StarFilledIcon from '../../../icons/star-filled.svg'

function EmailImportantButton({
  className = styles.EmailImportantButton,
  disabled,
  important,
  onSetImportant,
}) {
  const { t } = useTranslation()

  function handleToggleImportant(event) {
    if (!disabled) {
      stopPropagation(event)

      onSetImportant?.(!important)
    }
  }

  const buttonClassName = classNames(className, {
    [styles.disabled]: disabled,
  })

  return (
    <div className={buttonClassName} onClick={handleToggleImportant}>
      <FloatingTooltip
        content={t(
          important
            ? 'EmailTable.ActionSetUnimportantHintKey'
            : 'EmailTable.ActionSetImportantHintKey'
        )}
      >
        <div className={styles.iconContainer}>
          <IconNG
            Icon={important ? StarFilledIcon : StarEmptyIcon}
            className={styles.icon}
          />
          <div className={styles.iconBackground} />
        </div>
      </FloatingTooltip>
    </div>
  )
}

export default EmailImportantButton
